import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export const getDurationInMinutes = (
  lengthSec: number,
  includePlural?: boolean
) => {
  if (lengthSec) {
    const minutes = Math.floor(lengthSec / 60);

    if (lengthSec > 59) {
      return `${minutes} min${minutes > 1 && includePlural ? 's' : ''}`;
    }

    return `${lengthSec} sec`;
  }
  return '';
};

export const getTimestampAndISOTime = () => {
  const currentDate = dayjs();

  return {
    epoch: currentDate.valueOf(),
    iso_8601_datetime_tz: currentDate.toISOString()
  };
};

export const dateIsThisYear = (dateEpoch: number) => {
  const currentYear = dayjs().year();
  const dateYear = dayjs(dateEpoch).year();
  return currentYear === dateYear;
};

export const getDuration = (valueInSeconds: number) => {
  if (valueInSeconds === 0) return '00:00';

  const pad = (string: string) => {
    return `0${string}`.slice(-2);
  };

  const date = new Date(valueInSeconds * 1000);
  const hh = date.getUTCHours();
  const mm = pad(date.getUTCMinutes().toString());
  const ss = pad(date.getUTCSeconds().toString());

  if (hh) return `${hh}:${mm}:${ss}`;

  return `${mm}:${ss}`;
};

export const fromNow = (date: number) => {
  return dayjs(date).fromNow();
};
